import { Text } from '../Text';
import dayjs from 'shared/utils/dayjsConfig';
import NotificationIconCircle from '../Icons/NotificationIconCircle';
import { CancelIcon } from '../Icons';
import { baseGrey } from 'shared/utils/cssUtility';
import { useTranslationCustom } from 'shared/utils/hooks/useTranslationCustom';

import classes from './styles.module.scss';

interface NotificationProps {
  id: string;
  title: string;
  description: string;
  action?: string;
  createdAt: string;
  closeNotification: (id: string) => void;
  data?: {
    order: string;
  };
}

const SingleNotification: React.FC<NotificationProps> = ({
  id,
  title,
  description,
  action,
  createdAt,
  closeNotification,
  data
}) => {
  const t = useTranslationCustom();

  return (
    <>
      <div className={classes['single-notification-card']}>
        <div className="iconCustom_notification">
          <NotificationIconCircle />
        </div>
        <div className={classes['middle-content']}>
          <Text
            type="sf-caption"
            color="default"
            className={classes['notification-body__timeAgo']}
          >
            <span>{dayjs(createdAt).format('MMM D, YYYY')}</span>
            <span className={classes['datetime-separator']}>|</span>
            <span>{dayjs(createdAt).format('h:mmA')}</span>
          </Text>
          <Text type="sf-body-emphasized" color="default">
            {title}
          </Text>
          <Text type="sf-body-condensed" color="default">
            {description}
          </Text>
          {data?.order && (
            <Text type="sf-body-condensed" color="default">
              {t(
                'notifications.details',
                'The detailed information on the product can be found in the Education tab or on the'
              )}{' '}
              <Text
                component="a"
                href={`/visits/${data?.order}`}
                type="sf-body-condensed"
                color={'text-primary'}
              >
                order
              </Text>
              .
            </Text>
          )}
          <Text color={'theme-dark'} type="sf-body-emphasized">
            {action}
          </Text>
        </div>
        <div
          onClick={() => closeNotification(id)}
          className={classes['cancel-icon']}
        >
          <CancelIcon width={12.6} height={12.6} color={baseGrey} />
        </div>
      </div>
    </>
  );
};

export default SingleNotification;
